import { useEffect } from 'react';
import PageLoader from 'src/components/PageLoader';
import useAuth from 'src/hooks/useAuth';

const Callback = () => {
  const { handleAuthentication } = useAuth();

  useEffect(() => {
    handleAuthentication();
  }, []);

  return (
    <div>
      <PageLoader />
    </div>
  );
};

export default Callback;
